import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
  UncontrolledAlert,
  InputGroup,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MDBDataTable } from "mdbreact";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { reactLocalStorage } from "reactjs-localstorage";
import TimePicker from "react-time-picker";
import moment from "moment";
import HttpClient from "./../../utils/HttpClient";
import Select from "react-select";

class FormElements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Panel", link: "#" },
        { title: "Request Panel", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      // page states
      name: "",
      email: "",
      mobile: "",
      password: "",
      data: [],
      alert: false,
      message: "",
      type: "",
      result: [],
      edit_enable: false,
      edit_item_id: "",
      image_select: false,
      img_url: "",
      userId: "",
      userDetails: {},

      optionGroup: [],
      selectedGroup: "",

      app_id: "",
      sender_id: "",
    };
    this.handleDefault = this.handleDefault.bind(this);
    this.handleSelectGroup = this.handleSelectGroup.bind(this);
  }

  componentDidMount = async () => {
    this.checkUser();
  };

  handleDefault(date) {
    this.setState({ default_date: date });
  }

  handleSelectGroup = (selectedGroup) => {
    this.setState({ selectedGroup, sender_id: selectedGroup.value });
  };

  componentDidMount = async () => {
    await this.checkUser();
    // await this.checkExesisting();
  };

  checkUser = async () => {
    let user = await reactLocalStorage.getObject("userData");
    if (user != null && Object.keys(user).length > 0) {
      this.setState({
        userId: user.id,
        userDetails: user,
      });
      this.checkExesisting(user.id);
      this.fetchData();
      this.fetchEvents();
    } else {
    }
  };

  checkExesisting = async (id) => {
    //   alert();
    let sendData = { owner_id: id };
    let result = await HttpClient.requestData(
      "app-owner/application/check-pending",
      "POST",
      sendData
    );
    console.log("result checkExesisting", result);
    if (result && result.status > 0) {
      this.setState({
        // edit_enable: true,
        app_id: result.data[0].id,
      });
    }
  };
  fetchEvents = async () => {
    let result = await HttpClient.requestData("app-owner/fetch-all", "GET");
    if (result && result.status > 0) {
      let optionAppowner = {};
      optionAppowner.label = "App Owners";
      optionAppowner.options = [];
      let ooo = result.data.filter((item) => item.id != this.state.userId);
      ooo.map((item, index) => {
        optionAppowner.options.push({
          label: item.name,
          value: item.id,
        });
      });

      console.log("optionAppowner", optionAppowner);
      let newOptions = [];
      newOptions.push(optionAppowner);
      this.setState({ optionGroup: newOptions });
    } else {
      this.setState({});
    }
  };

  fetchData = async () => {
    let result = await HttpClient.requestData(
      "app-owner/panel/all-request",
      "POST",
      { sender_id: Number(this.state.userId) }
    );
    console.log("app-owner/panel/all-share", result);
    if (result && result.status) {
      let data = [];
      let i = 1;
      this.setState({ result: result.data });
      this.state.result.forEach((element, index) => {
        let rows = {
          sl: i,
          name: element.shareUserData ? element.shareUserData.name : "",
          shareUser: element.appOwnerData ? element.appOwnerData.name : "",
          date: moment(element.created_on).format("LL"),
          status:
            element.request_status == "Pending" ? (
              <>
                <button
                  title="Accept"
                  className={"btn btn-success mr-2"}
                  onClick={() => {
                    this.status(element, index, "Accepted");
                  }}
                >
                  {"Accept"}
                </button>
                <button
                  title="Accept"
                  className={"btn btn-danger mr-2"}
                  onClick={() => {
                    this.status(element, index, "Rejected");
                  }}
                >
                  {"Reject"}
                </button>
              </>
            ) : (
              <button title="Accept" className={"btn btn-success mr-2"}>
                {element.request_status}
              </button>
            ),
          action:
            element.request_status == "Accepted" ? (
              <>
                <button
                  title="Delete"
                  className="btn btn-primary mr-2"
                  // onClick={() => {
                  //   this.delete(element, index);
                  // }}
                >
                  <i className="fa fa-eye" />
                </button>
                {/* <button
                title="Edit"
                className="btn btn-primary"
                onClick={() => {
                  this.edit(element, index);
                }}
              >
                <i className="fa fa-edit" />
              </button> */}
              </>
            ) : null,
        };
        i++;
        data.push(rows);
      });
      this.setState({
        data: data,
      });
    } else {
      this.setState({
        data: [],
      });
    }
  };
  delete = async (item, index) => {
    let sendData = {
      id: item._id,
    };
    let result = await HttpClient.requestData(
      "app-owner/panel/delete",
      "POST",
      sendData
    );
    if (result && result.status) {
      let index = this.state.result.indexOf(item);
      if (index > -1) {
        this.state.result.splice(index, 1);
        this.setState({
          alert: true,
          message: "Deleted Succfully",
          type: "success",
        });
        setTimeout(() => {
          this.setState({
            alert: false,
            message: "",
            type: "",
          });
        }, 3000);
        this.fetchData();
      }
    }
  };
  edit = async (item, index) => {
    this.setState({
      edit_enable: true,
      name: item.name,
      details: item.details,
      date: new Date(item.default_date),
      time: item.time,
      edit_item_id: item._id,
      fileType: item.fileType,
      img_url: item.img_url,
      image_select: true,
      event_id: item.event_id,
    });
  };
  status = async (item, index, type) => {
    let sendData = {
      edit_id: item._id,
      request_status: type,
    };
    let result = await HttpClient.requestData(
      "app-owner/panel/update",
      "POST",
      sendData
    );
    if (result && result.status) {
      this.state.result.splice(index, 1);
      this.setState({
        alert: true,
        message: "Status Updated Succfully",
        type: "success",
      });
      setTimeout(() => {
        this.setState({
          alert: false,
          message: "",
          type: "",
        });
      }, 3000);
      this.fetchData();
    }
  };
  submit = async () => {
    if (this.state.app_id != "" && this.state.sender_id != "") {
      let data = null;
      let result = null;

      if (this.state.edit_enable == false) {
        data = {
          app_id: this.state.app_id,
          owner_id: this.state.userId,
          sender_id: this.state.sender_id,
        };
        console.log("data", data);
        console.log("selectedGroup", this.state.selectedGroup);
        // return false;
        result = await HttpClient.requestData(
          "app-owner/panel/share-panel",
          "POST",
          data
        );
      } else {
        data = {
          name: this.state.name,
          details: this.state.details,
          date: this.state.default_date,
          time: this.state.time,
          fileType: this.state.fileType,
          owner_id: this.state.userId,
          img_url: this.state.img_url,
          edit_id: this.state.edit_item_id,
        };
        result = await HttpClient.requestData(
          "app-owner/timeline/update",
          "POST",
          data
        );
      }
      console.log("result", result);
      if (result && result.status) {
        this.setState({
          alert: true,
          message: this.state.edit_enable
            ? "Timeline Updated Successfully"
            : "Panel Shared Successfully",
          type: "success",
          name: "",
          img_url: "",
          image_select: false,
          edit_enable: false,
          edit_item_id: "",
          selectedGroup: "",
          fileType: "",
          time: new Date(),
          default_date: new Date(),
          details: "",
        });

        this.fetchData();
      } else {
        this.setState({
          alert: true,
          message:
            typeof result.error == "string"
              ? result.error
              : result.error[0].msg,
          type: "danger",
        });
      }
    } else {
      this.setState({
        alert: true,
        message: "Please Fill Up All Details.",
        type: "warning",
      });
    }
    setTimeout(() => {
      this.setState({
        alert: false,
        message: "",
        type: "",
      });
    }, 3000);
  };

  imageUpload = async (e) => {
    let file = e.target.files[0].type;
    let fileType = file.split("/")[0];
    // fileType = fileType[0];
    console.log("e", file.split("/")[0]);

    if (fileType == "image" || fileType == "video") {
      // return false;
      this.setState({ fileType: fileType });
      let dataSend = { buckate: true, buckate_name: "appIcon" };

      let result = await HttpClient.newFileUpload(
        "image-upload/timeline",
        e.target.files[0],
        dataSend
      );
      console.log("result", result);
      if (result && result.status) {
        this.setState({ img_url: result.url, image_select: true });
      }
    } else {
      this.setState({
        alert: true,
        message: "Please Fill Up All Details.",
        type: "warning",
      });
    }
  };

  //   checkUser = async () => {
  //     let user = await reactLocalStorage.getObject("userData");
  //     if (user != null && Object.keys(user).length > 0) {
  //       this.setState({
  //         userId: user.id,
  //         userDetails: user,
  //       });
  //     } else {
  //     }

  //   };

  render() {
    const data = {
      columns: [
        {
          label: "Sl.",
          field: "sl",
          sort: "asc",
          width: 150,
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
          width: 270,
        },
        {
          label: "Owner Name",
          field: "shareUser",
          sort: "asc",
          width: 270,
        },
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 270,
        },

        {
          label: "Status",
          field: "status",
          sort: "asc",
          width: 100,
        },
        {
          label: "Action",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
      rows: this.state.data,
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title={this.state.breadcrumbItems[0].title}
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col xl={12}>
                <div className="card p-3">
                  <MDBDataTable responsive bordered data={data} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FormElements;
